<template>
  <div class="tab_head">
    <div class="left">
      <img
        class="img"
        src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/logo.png"
      />
    </div>
    <div class="right">
      <div class="tabs">
        <div
          class="item"
          @click="changeTabs(index)"
          v-for="(item, index) in tabs"
          :key="index"
        >
          <div class="text" :class="tabIndex == index ? 'text1' : ''">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
  props: {
    tabIndex: Number,
  },
  data() {
    return {
      tabs: [
        { name: "首页", path: "/website/home" },
        { name: "品牌IP", path: "" },
        { name: "二白Mini", path: "/website/product" },
        { name: "用户社区", path: "/website/community" },
        { name: "常见问题", path: "/website/question" },
        { name: "关于我们", path: "/website/about" },
      ],
    }
  },
  methods: {
    changeTabs(e) {
      if (this.tabs[e].path == "") {
        if (this.tabIndex != 0) {
          this.$router.push(this.tabs[0].path)
          setTimeout(() => {
            this.$emit("child-event", "ip")
          }, 1000)
          return
        } else {
          this.$emit("child-event", "ip")
          return
        }
      }
      if (this.tabIndex != e) {
        this.$router.push(this.tabs[e].path)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tab_head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 150px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: rgb(2 2 6 / 88%);
  .left {
    .img {
      width: 140px;
      height: 42px;
    }
  }
  .right {
    width: 50%;
    .tabs {
      display: grid;
      grid-row-gap: 2rem;
      grid-column-gap: 2rem;
      grid-template-rows: auto;
      grid-template-columns: repeat(6, 1fr);
      flex: 1;
      .item {
        .text {
          color: #c8c8cb;
          font-size: calc(24px * var(--scale));
          white-space: nowrap;
          cursor: pointer;
        }
        .text1 {
          color: #fff;
          font-size: calc(24px * var(--scale));
        }
      }
    }
  }
}
</style>
